const PROFESSIONAL_TYPE_TRANSLATIONS = {
	PSYCHOLOGIST: 'Psicólogo',
	DOCTOR_POSTGRADUATE: 'Médico',
	PSYCHIATRIST: 'Psiquiatra',
} as const;

const SERVICE_MODALITY_TRANSLATIONS = {
	FULL_REMOTE: 'Atendimento online',
	HYBRID: 'Atendimento Híbrido',
	FULL_PRESENCIAL: 'Atendimento presencial',
} as const;

const PROFESSIONAL_INFOS_TRANSLATIONS = {
	google_permissions_allowed: 'Google autorizado',
	clinic_name: 'Clínica',
	contract: 'Contrato',
} as const;

const CONTRACT_TYPE_TRANSLATION = {
	INDEPENDENT: 'Independente',
	PARTNER: 'Parceria',
} as const;

const PAYMENT_STATUS_TRANSLATION = {
	DONE: 'Concluído',
	FAILED: 'Recusado',
	WAITING: 'Aguardando',
	REFUNDED: 'Reembolsado',
	EXPIRED: 'Expirado',
} as const;

const SESSION_STATUS_TRANSLATION = {
	CONFIRMED: 'Confirmada',
	CREATED: 'Criado',
	STARTED: 'Iniciada',
	FINISHED: 'Finalizada',
	CANCELLED: 'Cancelada',
} as const;

const USER_PROPS_TRANSLATION = {
	email: 'Email',
	phone_number: 'Número do telefone',
	birthday: 'Data de nascimento',
	google_permissions_allowed: 'Google autorizado',
	created_at: 'Data de cadastro',
	last_login: 'Útimo login',
	last_ban: 'Útimo banimento',
	last_ban_reason: 'Motivo do banimento',
};

const UNAVAILABILITY_TYPE_TRANSLATION: Record<
	ProfessionalUnavailabilitys.UnavailabilityType,
	string
> = {
	VACATION: 'Férias',
	MEDICAL_LEAVE: 'Licença médica',
	PERSONAL_DAY: 'Dia pessoal',
	HOLIDAY: 'Feriado',
	CONFERENCE: 'Conferência/evento',
	TECHNICAL_ISSUE: 'Problemas técnicos',
	CUSTOM: 'Motivo personalizado',
} as const;

export type UserPropsTranslationKeys = keyof typeof USER_PROPS_TRANSLATION;

export {
	PROFESSIONAL_TYPE_TRANSLATIONS,
	SERVICE_MODALITY_TRANSLATIONS,
	PROFESSIONAL_INFOS_TRANSLATIONS,
	CONTRACT_TYPE_TRANSLATION,
	PAYMENT_STATUS_TRANSLATION,
	SESSION_STATUS_TRANSLATION,
	USER_PROPS_TRANSLATION,
	UNAVAILABILITY_TYPE_TRANSLATION,
};
